import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {Directive} from '@angular/core';
import {Logger} from '@app/logger.service';

const log = new Logger('DialogBase');

@Directive()
// tslint:disable-next-line:directive-class-suffix
export class DialogBase<I = any, O = any> {
    // tslint:disable-next-line:variable-name
    private readonly _data: I;

    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
        this._data = config?.data ?? {};
    }

    get data(): I {
        return this._data;
    }

    close(result: O){
        this.ref.close(result);
    }
}
